/**
 * Accepts a caller-supplied redirect target only if it stays inside this app.
 *
 * Anything reachable from a query string is attacker-controllable, so an
 * unchecked value here is an open redirect: a link to our own sign-in page that
 * lands the user on someone else's site, with our domain in the referrer and
 * their trust already established.
 */
export function safeInternalPath(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null

  const value = raw.trim()
  if (!value.startsWith('/')) return null

  // '//evil.com' is protocol-relative and leaves the origin entirely.
  if (value.startsWith('//')) return null

  // Browsers normalise backslashes to forward slashes in URLs, so '/\evil.com'
  // and '\\evil.com' are both escapes that a naive startsWith('/') check misses.
  if (value.includes('\\')) return null

  return value
}
